import { toTimeString } from "../utils/time.util";
/**
 * Extracts break periods from TimeLogEvent records
 * Pairs consecutive startBreak and endBreak events to create break periods
 * Handles edge cases like orphaned events and rejected/pending events
 *
 * @param events Array of TimeLogEvent records for a specific time entry
 * @returns Array of BreakPeriod objects, or empty array if no valid periods found
 */
export function extractBreakPeriods(events) {
    // Filter to accepted startBreak and endBreak events only
    const breakEvents = events
        .filter((e) => e.status === "accepted" && (e.action === "startBreak" || e.action === "endBreak"))
        .sort((a, b) => a.time.getTime() - b.time.getTime());
    const periods = [];
    let currentStart = null;
    for (const event of breakEvents) {
        if (event.action === "startBreak" && !currentStart) {
            currentStart = event.time;
        }
        else if (event.action === "endBreak" && currentStart) {
            const duration = ((event.time.getTime() - currentStart.getTime()) / (1000 * 60 * 60));
            periods.push({
                start: currentStart,
                end: event.time,
                duration,
                source: "logged",
            });
            currentStart = null;
        }
        // Skip orphaned/mismatched events (fail-safe)
    }
    return periods;
}
/**
 * Formats a single break period as a string
 * Format: "HH:MM-HH:MM"
 * Example: "09:00-09:30"
 *
 * @param period The break period to format
 * @returns Formatted string representation
 */
export function formatBreakPeriod(period) {
    const startTime = toTimeString(period.start);
    const endTime = toTimeString(period.end);
    return `${startTime}-${endTime}`;
}
/**
 * Formats multiple break periods with line breaks
 * Example: "09:00-09:30<br>13:00-13:15"
 *
 * @param periods Array of break periods to format
 * @returns Formatted string with all periods separated by HTML line breaks, or empty string if no periods
 */
export function formatBreakPeriods(periods) {
    if (periods.length === 0) {
        return "";
    }
    return [...periods.map(formatBreakPeriod)].join("<br>");
}
//# sourceMappingURL=break-period.util.js.map